import { HttpClient } from './http-client';
import { ApiError } from '../types';

export interface ExternalOrderSubmissionResponse {
  orderId: string;
  status: string;
  submittedAt: string;
  estimatedApprovalTime?: string;
  trackingUrl?: string;
}

export class ExternalOrderService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Submit an order using JSON format to the external orders API
   * @param orderData The order data to submit
   * @param divisionId Optional division ID to use for the order (sent as X-Division-Id header)
   */
  async submitJsonOrder(orderData: any, divisionId?: string): Promise<ExternalOrderSubmissionResponse> {
    const url = '/api/external/orders/json';
    
    try {
      const config = divisionId ? {
        headers: {
          'X-Division-Id': divisionId
        }
      } : undefined;
      
      const response = await this.httpClient.post(url, orderData, config);
      return response as ExternalOrderSubmissionResponse;
    } catch (error) {
      console.error('Error submitting JSON order:', error);
      throw error;
    }
  }

  /**
   * Get an external order by order number
   */
  async getExternalOrder(orderNumber: string): Promise<any> {
    const url = `/api/external/orders/${orderNumber}`;
    
    try {
      const response = await this.httpClient.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching external order:', error);
      throw error;
    }
  }
}